import React, { createContext, useEffect, useReducer } from "react"

const INITIAL_STATE ={
    coinID: localStorage.getItem("coinID") || "bitcoin" 
}

export const StarttrackingContext = createContext(INITIAL_STATE)

const StartTrackingReducer = ( state, action ) =>{
    switch( action.type ){
        case "ACTIONS":
            return{
                coinID: action.payload
            }
        default:{
            return state
        }
    }
}
export const StarttrackingContextProvider = ({children}) =>{
    const [ state, dispatch ] = useReducer(StartTrackingReducer, INITIAL_STATE)
    useEffect(()=>{
        localStorage.setItem("coinID" , state.coinID)
    },[state.coinID])

    return(
        <StarttrackingContext.Provider value={{ coinID: state.coinID , dispatch}}>
            {children}
        </StarttrackingContext.Provider>
    )
}
